

import { t } from "i18next"

import { ESystemEmailType } from "../container/systemEmails/components/tableListing/types"
import { TTemplateTagsFilterOptions } from "../utils/data/types"


export function templateTagsFilterOptions(extraObject?: TTemplateTagsFilterOptions): TTemplateTagsFilterOptions {
	const mergeableObj: TTemplateTagsFilterOptions = {}
	if (extraObject) {
		Object.keys(extraObject).forEach((filterName, index) => {
			mergeableObj[filterName] = []
			extraObject[filterName]?.forEach((filterItem) => {
				mergeableObj[filterName].push(filterItem)
			})
		})
	}
	return {
		type: [
			/*{
				text: t("email-tags-editors_all"),
				value: "all",
			},*/
			{
				text: t("email-tags-editors_html"),
				value: "html",
			},
			{
				text: t("email-tags-editors_bee"),
				value: "bee",
			},
			{
				text: t("email-tags-editors_smart"),
				value: "smart",
			}
		],
		usage: [
			/*{
				text: t("email-tags-usage_all"),
				value: "all",
			},*/
			{
				text: t("email-tags-usage_cv-resumes"),
				value: "cv-resumes",
			},
			{
				text: t("email-tags-usage_delivery"),
				value: "delivery",
			},
			{
				text: t("email-tags-usage_download"),
				value: "download",
			},
			{
				text: t("email-tags-usage_events"),
				value: "events",
			},
			{
				text: t("email-tags-usage_mystery-email"),
				value: "mystery-email",
			},
			{
				text: t("email-tags-usage_apologize-email"),
				value: "apologize-email",
			},
			{
				text: t("email-tags-usage_newsletter"),
				value: "newsletter",
			},
			{
				text: t("email-tags-usage_personal-note"),
				value: "personal-note",
			},
			{
				text: t("email-tags-usage_product-launch"),
				value: "product-launch",
			},
			{
				text: t("email-tags-usage_product-promotion"),
				value: "product-promotion",
			},
			{
				text: t("email-tags-usage_seasonal-promotion"),
				value: "seasonal-promotion",
			},
			{
				text: t("email-tags-usage_service-promotion"),
				value: "service-promotion",
			},
			{
				text: t("email-tags-usage_tutorial"),
				value: "tutorial",
			},
			{
				text: t("email-tags-usage_typography"),
				value: "typography",
			},
			{
				text: t("email-tags-usage_system-emails"),
				value: "system-emails",
			},
			{
				text: t("email-tags-usage_" + ESystemEmailType.accountConfirm),
				value: ESystemEmailType.accountConfirm,
			},
			{
				text: t("email-tags-usage_" + ESystemEmailType.userConfirm),
				value: ESystemEmailType.userConfirm,
			},
			{
				text: t("email-tags-usage_" + ESystemEmailType.senderConfirm),
				value: ESystemEmailType.senderConfirm,
			},
			{
				text: t("email-tags-usage_" + ESystemEmailType.passwordReset),
				value: ESystemEmailType.passwordReset,
			},
			{
				text: t("email-tags-usage_" + ESystemEmailType.contactDOptIn),
				value: ESystemEmailType.contactDOptIn,
			},
		],
		industry: [
			/*{
				text: t("email-tags-industry_all"),
				value: "all",

			},*/
			{
				text: t("email-tags-industry_automotive"),
				value: "automotive",
			},
			{
				text: t("email-tags-industry_business-services"),
				value: "business-services",
			},
			{
				text: t("email-tags-industry_computer-internet"),
				value: "computer-internet",
			},
			{
				text: t("email-tags-industry_cosmetics"),
				value: "cosmetics",
			},
			{
				text: t("email-tags-industry_education"),
				value: "education",
			},
			{
				text: t("email-tags-industry_electronics"),
				value: "electronics",
			},
			{
				text: t("email-tags-industry_financial-money"),
				value: "financial-money",
			},
			{
				text: t("email-tags-industry_fashion"),
				value: "fashion",
			},
			{
				text: t("email-tags-industry_food-beverage"),
				value: "food-beverage",
			},
			{
				text: t("email-tags-industry_health-wellness"),
				value: "health-wellness",
			},
			{
				text: t("email-tags-industry_hr"),
				value: "hr",
			},
			{
				text: t("email-tags-industry_manufacturing"),
				value: "manufacturing",
			},
			{
				text: (
					t("email-tags-industry_marketing-and-design")
				),
				value: "marketing-and-design",
			},
			{
				text: t("email-tags-industry_media-entertainment"),
				value: "media-entertainment",
			},
			{
				text: (
					t("email-tags-industry_news-blog-and-magazines")
				),
				value: "news-blog-and-magazines",
			},
			{
				text: t("email-tags-industry_non-profit"),
				value: "non-profit",
			},
			{
				text: t("email-tags-industry_others"),
				value: "others",
			},
			{
				text: (
					t("email-tags-industry_pets-and-animal-care")
				),
				value: "pets-and-animal-care",
			},
			{
				text: t("email-tags-industry_real-estate"),
				value: "real-estate",
			},
			{
				text: t("email-tags-industry_small-business"),
				value: "small-business",
			},
			{
				text: t("email-tags-industry_sports"),
				value: "sports",
			},
			{
				text: (
					t("email-tags-industry_transportation-storage")
				),
				value: "transportation-storage",
			},
			{
				text: t("email-tags-industry_travel-leisure"),
				value: "travel-leisure",
			},
		],
		seasonal: [
			/*{
				text: t("email-tags-seasonal_all"),
				value: "all",
			},*/
			{
				text: t("email-tags-seasonal_st-patricks-day"),
				value: "st-patricks-day",
			},
			{
				text: t("email-tags-seasonal_april-fools-day"),
				value: "april-fools-day",
			},
			{
				text: t("email-tags-seasonal_back-to-school"),
				value: "back-to-school",
			},
			{
				text: t("email-tags-seasonal_black-friday"),
				value: "black-friday",
			},
			{
				text: t("email-tags-seasonal_black-history-month"),
				value: "black-history-month",
			},
			{
				text: t("email-tags-seasonal_book-lovers-day"),
				value: "book-lovers-day",
			},
			{
				text: t("email-tags-seasonal_breast-cancer"),
				value: "breast-cancer",
			},
			{
				text: t("email-tags-seasonal_chinese-new-year"),
				value: "chinese-new-year",
			},
			{
				text: t("email-tags-seasonal_christmas"),
				value: "christmas",
			},
			{
				text: t("email-tags-seasonal_cinco-de-mayo"),
				value: "cinco-de-mayo",
			},
			{
				text: t("email-tags-seasonal_cyber-monday"),
				value: "cyber-monday",
			},
			{
				text: t("email-tags-seasonal_earth-day"),
				value: "earth-day",
			},
			{
				text: t("email-tags-seasonal_easter"),
				value: "easter",
			},
			{
				text: t("email-tags-seasonal_fashion-week"),
				value: "fashion-week",
			},
			{
				text: t("email-tags-seasonal_fathers-day"),
				value: "fathers-day",
			},
			{
				text: t("email-tags-seasonal_giving-tuesday"),
				value: "giving-tuesday",
			},
			{
				text: t("email-tags-seasonal_first-day-of-fall"),
				value: "first-day-of-fall",
			},
			{
				text: t("email-tags-seasonal_first-day-of-winter"),
				value: "first-day-of-winter",
			},
			{
				text: t("email-tags-seasonal_halloween"),
				value: "halloween",
			},
			{
				text: t("email-tags-seasonal_hanukkah"),
				value: "hanukkah",
			},
			{
				text: t("email-tags-seasonal_independence-day"),
				value: "independence-day",
			},
			{
				text: (
					t("email-tags-seasonal_international-coffee-day")
				),
				value: "international-coffee-day",
			},
			{
				text: (
					t("email-tags-seasonal_international-womens-day")
				),
				value: "international-womens-day",
			},
			{
				text: t("email-tags-seasonal_labor-day"),
				value: "labor-day",
			},
			{
				text: t("email-tags-seasonal_lgbtq-pride-month"),
				value: "lgbtq-pride-month",
			},
			{
				text: t("email-tags-seasonal_mardi-gras"),
				value: "mardi-gras",
			},
			{
				text: t("email-tags-seasonal_memorial-day"),

				value: "memorial-day",
			},
			{
				text: t("email-tags-seasonal_mothers-day"),
				value: "mothers-day",
			},
			{
				text: t("email-tags-seasonal_new-year"),

				value: "new-year",
			},
			{
				text: (
					t("email-tags-seasonal_small-business-saturday")
				),

				value: "small-business-saturday",
			},
			{
				text: t("email-tags-seasonal_spring"),

				value: "spring",
			},
			{
				text: t("email-tags-seasonal_super-bowl"),

				value: "super-bowl",
			},
			{
				text: t("email-tags-seasonal_thanksgiving"),

				value: "thanksgiving",
			},
			{
				text: t("email-tags-seasonal_valentines-day"),

				value: "valentines-day",
			},
			{
				text: t("email-tags-seasonal_video-games-day"),

				value: "video-games-day",
			},
			{
				text: t("email-tags-seasonal_womens-equality-day"),

				value: "womens-equality-day",
			},
			{
				text: t("email-tags-seasonal_world-emoji-day"),

				value: "world-emoji-day",
			},
			{
				text: (
					t("email-tags-seasonal_world-meditation-day")
				),

				value: "world-meditation-day",
			},
			{
				text: t("email-tags-seasonal_single-day"),

				value: "single-day",
			},
			{
				text: t("email-tags-seasonal_waitangi"),

				value: "waitangi",
			},
			{
				text: (
					t("email-tags-seasonal_get-to-know-your-customer")
				),

				value: "get-to-know-your-customer",
			},
		],
		plan: [
			{ text: t("general-free-DD"), value: "free" },
			{ text: t("general-paid-dd"), value: "paid" }
		],
		...extraObject
	}
}

export enum ETemplatesFilters {
	usage = "usage",
	industry = "industry",
	seasonal = "seasonal",
	editor = "type",
	plan = "plan",
	noFilters = "noFilters"
}


export function getSimpleTemplateTagsValues(filter: ETemplatesFilters | string, extraObject?: TTemplateTagsFilterOptions) {
	return templateTagsFilterOptions(extraObject)[filter]?.map((t) => filter + "_" + t.value)
}